import { cn } from "@pax/ui";
import { Bell } from "lucide-react";

/**
 * Where your notifications will open, between your name and your credits. Notifications aren't
 * built yet, so it holds the place and says so.
 */
export function NotificationsButton({ className }: { className?: string }) {
  return (
    <span
      role="img"
      aria-label="Notifications, coming soon"
      title="Notifications · Soon"
      className={cn(
        "grid size-8 shrink-0 place-items-center rounded-full text-muted-foreground/60",
        className,
      )}
    >
      <Bell aria-hidden className="size-4" />
    </span>
  );
}
